var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoSessionLimit = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bell_1_",
    "data-name": "bell (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_47374",
    "data-name": "Path 47374",
    d: "M357.988,23.594a.739.739,0,0,1-.727-.75,7.951,7.951,0,0,0-2.236-5.569.766.766,0,0,1,0-1.06.711.711,0,0,1,1.028,0,9.463,9.463,0,0,1,2.663,6.629A.739.739,0,0,1,357.988,23.594Zm0,0",
    transform: "translate(-342.716 -15.433)",
    fill: "#74276b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_47375",
    "data-name": "Path 47375",
    d: "M.727,23.594A.739.739,0,0,1,0,22.844a9.463,9.463,0,0,1,2.663-6.629.711.711,0,0,1,1.028,0,.766.766,0,0,1,0,1.06,7.949,7.949,0,0,0-2.236,5.569A.739.739,0,0,1,.727,23.594Zm0,0",
    transform: "translate(0 -15.433)",
    fill: "#74276b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_47376",
    "data-name": "Path 47376",
    d: "M35.426,12.685A5.089,5.089,0,0,1,33.7,8.841V6.75a5.2,5.2,0,0,0-4.364-5.19V.75a.728.728,0,1,0-1.455,0v.81a5.2,5.2,0,0,0-4.364,5.19V8.841a5.094,5.094,0,0,1-1.737,3.85,1.327,1.327,0,0,0-.445,1A1.3,1.3,0,0,0,22.6,15h12a1.294,1.294,0,0,0,1.273-1.313A1.333,1.333,0,0,0,35.426,12.685Zm0,0",
    transform: "translate(-20.605)",
    fill: "#74276b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_47377",
    "data-name": "Path 47377",
    d: "M158.961,450.25a2.754,2.754,0,0,0,2.672-2.25h-5.344A2.754,2.754,0,0,0,158.961,450.25Zm0,0",
    transform: "translate(-150.961 -432.25)",
    fill: "#74276b"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoSessionLimit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_session_limit.e6af2cc5bb667395b7b6a6aa671c6539.svg";